import { ConfigManager } from '../gmwc-core/gmwc-core';

export default new class CaptchaProvider {
    constructor() {
        this._cache = {};
        this.queryString = '?';
        this.component = 'captcha';
        const host = process.env;

        ConfigManager.onPropertyChange(['endpoint', 'pcf'], hiddenState => {

                        let pcf = hiddenState.pcf && hiddenState.pcf.newValue ? hiddenState.pcf.newValue : undefined;

                        if (pcf && pcf.indexOf('${component}') > -1 ) {
                            pcf = pcf.replace('${component}', this.component);
                        }

                        if (hiddenState.endpoint && hiddenState.endpoint.newValue) this.endpoint = pcf || hiddenState.endpoint.newValue + 'captcha-cws/';

        });
    }

    captchaID(cID) {
        let value = 'captchaID',
            response;
        const request = new Request(`${this.endpoint}${value}${this.queryString}cID=${cID}`);

        response = fetch(request, {cache: 'no-store'}).then(res => {
                                            if (res.status == 200) {
                                                return res.text();
                                            }
                                            else {
                                                console.log('Error: ' + res.status);
                                            }
                                    }).catch((e) => {
                                      //Adding for webpack
                                    }).then(ID => {
                                        return `${ID}`;
                                    }).catch((e) => {
                                      //Adding for webpack
                    });
                                      return response;
    }

    captchaImage(cID) {
        let value = 'captchaImage',
            image = new Image(),
            imageString,
            imageElement,
            response,
            timeStamp = Date.now();
        const request = new Request(`${this.endpoint}${value}${this.queryString}cID=${cID}&timeStamp=${timeStamp}`);

        response = fetch(request, {cache: 'no-store'}).then(res => {
                                            if (res.status == 200) {
                                                return res.text();
                                            } else {
                                                console.log('Error: ' + res.status);
                                            }
                                }).catch((e) => {//Adding for webpack
                                  }).then(imageString => {
                                    return imageString.slice(1, imageString.length -1);
                                }).catch((e) => {//Adding for webpack
                                    }).then(imageString => {
                                    image.src = `data:image/png;base64,${imageString}`;
                                    image.alt = 'Captcha Image';
                                    image.className = "gmst-captcha-image";
                                    image.id = "captchaImage";
                                    return image;
                                }).catch((e) => {
                                  //Adding for webpack
                                });
        return response;
    }

    validate(cID, input) {
        let value = 'validate',
            response;

        const request = new Request(`${this.endpoint}${value}${this.queryString}cID=${cID}&captcha=${input}`);
    
        response = fetch(request, {method: 'POST', cache: 'no-store'}).then(res => {
                                            if (res.status == 200) {
                                                return res.text();
                                            } else {
                                                console.log('Error: ' + res.status);
                                                return `FAIL: Server Error`;
                                            }          
                                        });
        return response;
    }
}